module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "ui active centered inline large loader"
  })]) : _c('div', {
    staticClass: "ui grid",
    staticStyle: {
      "padding": "20px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "sixteen wide column"
  }, [_c('div', {
    staticClass: "ui form"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui checkbox labelCursorFix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.skipPackageDimensionChangeIfNoFeeChange),
      expression: "skipPackageDimensionChangeIfNoFeeChange"
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "id": "checkbox334456"
    },
    domProps: {
      "checked": Array.isArray(_vm.skipPackageDimensionChangeIfNoFeeChange) ? _vm._i(_vm.skipPackageDimensionChangeIfNoFeeChange, null) > -1 : (_vm.skipPackageDimensionChangeIfNoFeeChange)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.skipPackageDimensionChangeIfNoFeeChange,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.skipPackageDimensionChangeIfNoFeeChange = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.skipPackageDimensionChangeIfNoFeeChange = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.skipPackageDimensionChangeIfNoFeeChange = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox334456"
    }
  }, [_vm._v("Dimension changes: Only alert if FBA fee changed as well")])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui checkbox labelCursorFix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alertForParentChanges),
      expression: "alertForParentChanges"
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "id": "checkbox334458"
    },
    domProps: {
      "checked": Array.isArray(_vm.alertForParentChanges) ? _vm._i(_vm.alertForParentChanges, null) > -1 : (_vm.alertForParentChanges)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.alertForParentChanges,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.alertForParentChanges = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.alertForParentChanges = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.alertForParentChanges = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox334458"
    }
  }, [_vm._v("Parent ASIN: Alert if parent ASIN changes")])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui checkbox labelCursorFix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alertForOwnOfferPriceChanges),
      expression: "alertForOwnOfferPriceChanges"
    }],
    attrs: {
      "type": "checkbox",
      "data-lpignore": "true",
      "id": "checkbox334459"
    },
    domProps: {
      "checked": Array.isArray(_vm.alertForOwnOfferPriceChanges) ? _vm._i(_vm.alertForOwnOfferPriceChanges, null) > -1 : (_vm.alertForOwnOfferPriceChanges)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.alertForOwnOfferPriceChanges,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.alertForOwnOfferPriceChanges = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.alertForOwnOfferPriceChanges = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.alertForOwnOfferPriceChanges = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox334459"
    }
  }, [_vm._v("Offer price: Alert if your offer price changes")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "six wide column"
  }, [_c('button', {
    class: _vm.dirty ? 'ui primary button' : 'ui disabled primary button',
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "ui basic button",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "six wide column"
  }, [_c('div', {
    staticClass: "ui header"
  }, [_vm._v("Configuration")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-00fde226!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/ProductDetailsRecentChangeConfig.vue
// module id = 713
// module chunks = 2